import { useState } from "react";

interface RippleData {
  id: number;
  x: number;
  y: number;
  size: number;
}

export const useRipple = () => {
  const [ripples, setRipples] = useState<RippleData[]>([]);

  const create = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const target = event.currentTarget;
    const rect = target.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    setRipples((prev) => [...prev, { id: Date.now(), x, y, size }]);
  };

  const remove = (id: number) => {
    setRipples((prev) => prev.filter((r) => r.id !== id));
  };

  return { ripples, create, remove };
};
